/**
 * firestore.rules (GitHub #132) let only staff read other churches' courses,
 * groups and invites, and Firestore refuses a whole query when it could return
 * a doc the caller can't read. So queries from everyone else filter by their
 * own church.
 */

const STAFF_ROLES = ['superAdmin', 'helpDesk', 'owner']

/** Whether the signed-in user can see every church. */
export function isStaffUser(store) {
  const roles = store.getters['UserData/getRoles'] || []
  return roles.some((role) => STAFF_ROLES.includes(role))
}

/**
 * Adds where('cid', '==', <current church>) unless the user is staff. A user
 * with no church matches nothing rather than being refused.
 */
export function scopeToChurch(query, store) {
  if (isStaffUser(store)) return query
  return query.where('cid', '==', store.getters['AppData/cid'] || '')
}
